import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-detailed-generic-user',
    templateUrl: './detailed-generic-user.component.html',
    styleUrls: ['./detailed-generic-user.component.scss'],
    standalone: false
})
export class DetailedGenericUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
